import { IOrderedWithPaginationInputModel } from 'inputModels';
import { IInvoiceViewModel, IResponse } from 'viewModels';
import api from 'services/api';

const getUserInvoices = <T>(
  userId: string,
  input?: IOrderedWithPaginationInputModel<T>
) =>
  new Promise<IResponse<IInvoiceViewModel[]>>((resolve, reject) => {
    api
      .get(
        `invoice/user/${userId}?page=${input?.page || 1}&take=${
          input?.take || 10
        }`
      )
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const getInvoiceById = (invoiceId: string) =>
  new Promise<IResponse<IInvoiceViewModel>>((resolve, reject) => {
    api
      .get(`invoice/${invoiceId}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const closeInvoiceForPeriod = (
  userId: string,
  startDate: string,
  endDate: string
) =>
  new Promise<IResponse<IInvoiceViewModel>>((resolve, reject) => {
    api
      .post(
        `invoice/close?userId=${userId}&startDate=${startDate}&endDate=${endDate}`
      )
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const closeInvoiceForPreviousMonth = (userId: string) =>
  new Promise<IResponse<IInvoiceViewModel>>((resolve, reject) => {
    api
      .post(`invoice/close-month?userId=${userId}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const exportInvoicePdf = (invoiceId: string) =>
  new Promise<void>((resolve, reject) => {
    api
      .get(`invoice/${invoiceId}/export`, {
        responseType: 'blob',
      })
      .then(({ data }) => {
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `fatura-${invoiceId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        resolve();
      })
      .catch(reject);
  });

const exportInvoicePdfDetailed = (invoiceId: string) =>
  new Promise<void>((resolve, reject) => {
    api
      .get(`invoice/${invoiceId}/export-detailed`, {
        responseType: 'blob',
      })
      .then(({ data }) => {
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `fatura_detalhada-${invoiceId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        resolve();
      })
      .catch(reject);
  });

const markInvoiceAsPaid = (invoiceId: string) =>
  new Promise<IResponse<void>>((resolve, reject) => {
    api
      .put(`invoice/${invoiceId}/mark-as-paid`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const InvoiceController = {
  getUserInvoices,
  getInvoiceById,
  closeInvoiceForPeriod,
  closeInvoiceForPreviousMonth,
  exportInvoicePdf,
  exportInvoicePdfDetailed,
  markInvoiceAsPaid,
};

export default InvoiceController;
